import React, {useCallback, useEffect, useRef} from 'react';
import {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {FormRef, GroupItem, SimpleItem} from "devextreme-react/form";
import IClientTitre from '../../models/IClientTitre';
import {FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar} from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

interface IConfigurationClientsTitresProps {
    isModeSelection?: boolean,
}

export default function ConfigurationClientsTitres({isModeSelection}: IConfigurationClientsTitresProps) {
    const clientTitreFormDataSource = useCustomDataSource<IClientTitre, IClientTitre>({path: "clientTitre", primaryKey: "idClientTitre"});
    const {setMainForm, selectedDataRow: selectedClientTitre, mode, setMode, isFieldModifier, onFieldDataChanged} = clientTitreFormDataSource;
    const formRef = useRef<FormRef>(null);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode !== Mode.Lecture)
            formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])

    const onFocusedRowChanged = useCallback((E: any) => {
        if (mode === Mode.Modifier) {
            setMode(Mode.Lecture);
        }
    }, [mode]);
    return (
        <FormListBase data={clientTitreFormDataSource}>
            <FormListBaseGrid dataSource={clientTitreFormDataSource.dataSource} onFocusedRowChanged={onFocusedRowChanged}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseToolbar removeBlocked={true} headerText={`${selectedClientTitre?.description || ''}`} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || mode !== Mode.Lecture
                ? <FormListBaseTab>
                    <TabItem title="Informations">
                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClientTitre || {} as IClientTitre} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                            <GroupItem>
                                <SimpleItem key={"frm-description"} dataField={"description"}/>
                            </GroupItem>
                        </Form>
                    </TabItem>
                    <TabItem title="Système"><FormSysteme formData={selectedClientTitre || {} as IClientTitre}/></TabItem>
                </FormListBaseTab> : null}
        </FormListBase>
    );
}